export function uuid() {
  if (!window.crypto?.randomUUID) {
    // JSDOM doesn't support crypto.getRandomValues() so we need to use Math.random() instead
    return Math.random().toString(36).slice(2);
  }

  return window.crypto.randomUUID();
}
